if (!customElements.get('banners-tabs')) {
  class BannersTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = [...this.querySelectorAll('.banners-tabs__tab')];
      this.panels = [...this.querySelectorAll('.banners-tabs__panel')];

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this._activate(parseInt(tab.dataset.index)));
      });
    }

    _activate(index) {
      this.tabs.forEach((tab, i) => {
        const isActive = i === index;
        tab.classList.toggle('banners-tabs__tab--active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      this.panels.forEach((panel, i) => {
        panel.classList.toggle('banners-tabs__panel--hidden', i !== index);
      });
    }
  }

  customElements.define('banners-tabs', BannersTabs);
}
